import { ProductItem } from '@ph-model/response';

export const productIdGenerator = (product: ProductItem) =>
  `${product.planSKU}${product.minTerm}${product.maxTerm}${product.deductible}${product.baseDealerCost}`;
